import React from 'react';
import { RoutingStore } from '../../../stores/RoutingStore';
import { Widget } from '../Widget/Widget';
import { Widget as WidgetV2 } from '../WidgetV2/Widget';
import { Template as TemplateType } from '../../../../../types/api';
import { ExperimentsStore } from '../../../../stores/ExperimentsStore';
import { injectV2 } from '../../../injectV2';
import { WidgetType } from '../../../stores/TemplatesStore';
import { Template } from '../Template/Template';
import { templatesGridDataHooks } from './TemplatesGrid.dataHooks';
import s from './TemplatesGrid.scss';

interface TemplatesGridProps {
  routingStore: RoutingStore;
  experimentsStore: ExperimentsStore;
  dataHook?: string;
  itemsPerPage?: [number, TemplateType[]][];
  itemsPerPageUUID: string;
  widgetType: WidgetType | null;
  categorySlug: string | 'search' | null;
  subCategorySlug: string | null;
}

class TemplatesGridCmp extends React.Component<TemplatesGridProps> {
  private pageRefs: { [page: number]: HTMLLIElement } = {};

  public componentDidUpdate(prevProps: TemplatesGridProps) {
    if (
      prevProps.itemsPerPageUUID !== this.props.itemsPerPageUUID ||
      prevProps.itemsPerPage?.length !== this.props.itemsPerPage?.length
    ) {
      this.scrollToTemplates();
    }
  }

  private scrollToTemplates() {
    const page =
      this.props.routingStore.matchedRoute.routeName !== 'home' &&
      this.props.routingStore.matchedRoute.routeName !== 'forYou'
        ? this.props.routingStore.matchedRoute.params.page
        : 1;

    const templateElement = this.pageRefs[page];

    templateElement && templateElement.getBoundingClientRect().top < 0 && templateElement.scrollIntoView();
  }

  private renderWidget = () => {
    const { experimentsStore, widgetType } = this.props;

    if (experimentsStore.is('specs.funnel.TemplatesGalleryEnableWidget', 'Disabled')) {
      return null;
    }

    const isOldWidget = experimentsStore.is('specs.funnel.TemplatesGalleryEnableWidget', 'OldWidget');
    const WidgetComponent = isOldWidget ? Widget : WidgetV2;

    return <WidgetComponent type={widgetType} dataHook={templatesGridDataHooks.widget()} />;
  };

  public render() {
    const { dataHook, itemsPerPage } = this.props;
    const templateItems = [...(itemsPerPage || [])].sort(([page1], [page2]) => page1 - page2);
    const { categorySlug, subCategorySlug } = this.props;

    return (
      <ul className={s.templates} data-hook={dataHook}>
        {this.renderWidget()}
        {templateItems.map(([page, templates]) =>
          templates.map((template, indexInPage) => (
            <Template
              dataHook={templatesGridDataHooks.template({ page })}
              key={template.id}
              template={template}
              galleryDocIndex={indexInPage}
              forwardedRef={indexInPage === 0 ? (ref) => (this.pageRefs[page] = ref) : undefined}
              categorySlug={categorySlug}
              subCategorySlug={subCategorySlug}
            />
          )),
        )}
      </ul>
    );
  }
}

export const TemplatesGrid = injectV2('routingStore', 'experimentsStore')(TemplatesGridCmp);
